import { useMutation } from '@tanstack/react-query';
import * as api from 'util/api';

export default ({ onSuccess, onError, onSettled } = {}) => useMutation({
  mutationKey: ['segmentation', 'retry-run'],
  mutationFn: (runId) => api.retrySegmentationRun(runId),
  onSuccess,
  onError,
  onSettled,
});
